/*!jslint
  this
*/
jQuery(function ($) {
    "use strict";
    $('select').selectric(
        {
            disableOnMobile: false,
            nativeOnMobile: false,
        }
    );


    function appHeight() {
        var wh = $(window).innerHeight();
        document.documentElement.style
            .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $(document).on('click', '.nav-toggle', function (e) {
        $(this).toggleClass('on');
        $('html').toggleClass('nav-open');
    });
    $(window).on('scroll', function () {
        var ST = $(this).scrollTop();
        if (ST > 100) {
            $('.site-header').addClass('sticky');
        } else {
            $('.site-header').removeClass('sticky');
        }
    });

    $('.mgh-slide-images').beforeAfter({
        movable: true,
        clickMove: true,
        position: 50,
        separatorColor: '#fafafa',
        bulletColor: '#fafafa',
        onMoveStart: function (e) {
            console.log(event.target);
        },
        onMoving: function () {
            console.log(event.target);
        },
        onMoveEnd: function () {
            console.log(event.target);
        },
    });
    $(document).on('click', '.loadmore', function (e) {
        e.preventDefault();
        var $el = $(this),
            link = $el.attr('href');
        if ($el.attr('disabled'))
            return;
        $el.addClass('loading').attr('disabled', true);
        $el.find('span').html('Loading...')
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").append($(this).find("#loadmorecontainer").html());
            $el.parents('.load-more').removeAttr('disabled').remove();
        });
    });
    $(document).on('click', '.mobile-nav \.button', function () {
        $('html').removeClass('nav-open');
        $('.nav-toggle').removeClass('on');
    });

    $('.scheme-img-sl').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        autoplaySpeed: 4000,
    });
    // $('.mgh-images-cl').slick({
    //     dots: true,
    //     infinite: true,
    //     arrows: false,
    //     slidesToShow: 1,
    //     autoplay: true,
    //     autoplaySpeed: 4000,
    // });
    $('.gallery-cards-cl').slick({
        dots: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });



    $(document).on('click', '.cat-dtls-tab-head', function (e) {
        $('.cat-dtls-tab').removeClass('tab-open');
        $('.cat-dtls-tab-cnt').slideUp('normal');
        if ($(this).next().is(':hidden') == true) {
            $(this).parent().addClass('tab-open');
            $(this).next().slideDown('normal');
        }
    });
    $('.event-cf').magnificPopup({
        items: {
            src: '#event-form',
            type: 'inline'
        },
        closeBtnInside: true,
    });

    $(document).on('gform_post_render', function (event, form_id) {
        if (form_id === 5 || form_id === 8) {
            $('.stay input[type="number"]').each(function () {
                if (!jQuery(this).parent().hasClass('no-of-stay')) {
                    $('.stay input[type="number"]').wrap('<div class="no-of-stay"></div>');
                    $('.stay input[type="number"]').before('<button type="button" class="minus-btn disabled">-</button>');
                    $('.stay input[type="number"]').after('<button type="button" class="plus-btn">+</button>');
                }
            });
            $('.minus-btn').click(function () {
                let input = $(this).siblings('input[type="number"]');
                updateValue(input, -1);
            });

            $('.plus-btn').click(function () {
                let input = $(this).siblings('input[type="number"]');
                updateValue(input, 1);
            });
            function updateValue(input, delta) {
                let min = parseInt(input.attr('min')) || -Infinity;
                let max = parseInt(input.attr('max')) || Infinity;
                let currentValue = parseInt(input.val());
                if (!isNaN(currentValue)) {
                    let newValue = currentValue + delta;
                    if (newValue >= min && newValue <= max) {
                        input.val(newValue);
                        checkButtonState(input, min, max);
                    }
                }
            }
            function checkButtonState(input, min, max) {
                let value = parseInt(input.val());
                if (value <= min) {
                    input.siblings('.minus-btn').addClass('disabled');
                } else {
                    input.siblings('.minus-btn').removeClass('disabled');
                }

                if (value >= max) {
                    input.siblings('.plus-btn').addClass('disabled');
                } else {
                    input.siblings('.plus-btn').removeClass('disabled');
                }
            }
        }
    });
    $('.stay input[type="number"]').each(function () {
        let min = $(this).attr('min');
        if (min) {
            $(this).val(min);
        }
    });
    gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
        optionsObj.changeMonth = false;
        optionsObj.changeYear = false;

        if (formId == 5 && fieldId == 6) {
            optionsObj.minDate = 1;
            optionsObj.onClose = function (dateText, inst) {
                if (dateText) {
                    var date = (inst?.currentMonth + 1) + '/' + inst?.currentDay + '/' + inst?.currentYear;
                    // console.log(dateText, inst)
                    var result = new Date(date);
                    result.setDate(result.getDate() + 2);
                    // $('#input_5_11').datepicker('option', 'minDate', result).datepicker('setDate', result);
                    $('#input_5_11').datepicker('option', 'minDate', result).datepicker('option', 'dateFormat', 'dd/mm/yy',).datepicker('setDate', result);
                }
            };
        }
        if (formId == 5 && fieldId == 11) {
            optionsObj.minDate = 1;
            optionsObj.beforeShowDay = function (date) {
                var checkinDate = $('#input_5_6').datepicker('getDate');
                if (!checkinDate) {
                    return [true, ''];
                }
                var checkoutDate = $('#input_5_11').datepicker('getDate');
                if (date > checkinDate && (!checkoutDate || date < checkoutDate)) {
                    return [true, 'highlight-date'];
                }
                return [true, ''];
            };
        }
        return optionsObj;
    });
    $('.back-btn a').on('click', function (event) {
        event.preventDefault();
        window.history.back();
        return false;
    });
    $('.cf-stay').magnificPopup({
        items: {
            src: '#stay-enhance',
            type: 'inline'
        },

    });
    $('.events-cl').slick({
        dots: false,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 2,
        prevArrow: '<div class="slick-custom-arrow slick-custom-arrow-left"></div>',
        nextArrow: '<div class="slick-custom-arrow slick-custom-arrow-right"></div>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            },
        ]
    });

    $('.sl-icon-lt').on('click', function (event) {
        $('.events-cl').slick('slickPrev');
    });
    $('.sl-icon-rt').on('click', function (event) {
        $('.events-cl').slick('slickNext');
    });
    $(document).on('click', '.download-fp', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
        $.magnificPopup.open({
            items: {
                src: '#floorplans-form'
            },
            type: 'inline',
            midClick: true,
            // callbacks: {
            //     close: function () {
            //         location.reload();
            //     }
            // }
        });
    });


    $('.event-cf').on('click', function (e) {
        e.preventDefault();
        // if (!window.localStorage.getItem('downloadfloorplan')) {
        var catId = $(this).data('id');
        var popupId = '#floorplans-' + catId;
        $.magnificPopup.open({
            items: {
                src: popupId
            },
            type: 'inline',
            midClick: true,
            // callbacks: {
            //     close: function () {
            //         location.reload();
            //     }
            // }
        });

        // }
        var pdf = $(this).data('pdf');
        $('.download-fp').attr('data-pdf', pdf);

    });

    // if ($('.events-wed').length) {
    //     $(window).on('scroll', function () {
    //         if ($(window).width() > 991) {
    //             var scrollPosition = $(this).scrollTop();
    //             var sectionOffset = $('.events-wed').offset().top;
    //             var sectionHeight = $('.events-wed').outerHeight();
    //             if (scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
    //                 var sectionScroll = scrollPosition - sectionOffset;
    //                 // $('.events-wed').css('transform', 'translateY(' + (-sectionScroll * 0.5) + 'px)');
    //                 $('.events-wed .card-img').each(function () {
    //                     var speed = $(this).data('speed') || 0.5;
    //                     $(this).css('transform', 'translateY(-' + (sectionScroll * speed) + 'px)');
    //                 });
    //                 $('.events-wed-img-l').css('transform', 'translateY(-' + (sectionScroll * 0.05) + 'px)');
    //             }
    //         }
    //     });
    // }
    // if ($('.events-weddark').length) {
    //     $(window).on('scroll', function () {
    //         if ($(window).width() > 991) {
    //             var scrollPosition = $(this).scrollTop();
    //             var sectionOffset = $('.events-weddark').offset().top;
    //             var sectionHeight = $('.events-weddark').outerHeight();
    //             if (scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
    //                 var sectionScroll = scrollPosition - sectionOffset;
    //                 // $('.events-wed').css('transform', 'translateY(' + (-sectionScroll * 0.5) + 'px)');
    //                 $('.events-weddark .card-img').each(function () {
    //                     var speed = $(this).data('speed') || 0.5;
    //                     $(this).css('transform', 'translateY(-' + (sectionScroll * speed) + 'px)');
    //                 });
    //                 $('.events-weddark-img-l').css('transform', 'translateY(-' + (sectionScroll * 0.25) + 'px)');
    //             }
    //         }
    //     });
    // }
    // if (!window.localStorage.getItem('downloadfloorplan')) {
    $('.cf-form').magnificPopup({
        type: 'inline',
        items: {
            src: '#floorplans',
            type: 'inline'
        },
        closeBtnInside: true,
        callbacks: {
            close: function () {
                location.reload();
            }
        }
    });
    // }
    // $('.cf-form-2').magnificPopup({
    //     type: 'inline',
    //     items: {
    //         src: '#floorplan-2',
    //         type: 'inline'
    //     },
    //     closeBtnInside: true,
    //     callbacks: {
    //         close: function () {
    //             location.reload();
    //         }
    //     }
    // });

    $('.disc-enhance').magnificPopup({
        items: {
            src: '#disc-enhance',
            type: 'inline'
        },
        closeBtnInside: true
    });
    $(document).on('gform_confirmation_loaded', function (event, formId) {
        var formIds = [2, 3];
        if (formIds.includes(formId)) {
            // window.localStorage.setItem('downloadfloorplan', true);
            var pdfurl = $('#download-file').data('pdf');
            var anchorTag = $('<a href="' + pdfurl + '" class="button download-pdf" target="_blank">click here to view</a>')
            // setTimeout(function () {
            //     $('#floorplan-download')[0].click();
            // }, 1000);

            $('.cf-plans-in').addClass('download');
            $('.download .gform_confirmation_wrapper').append(anchorTag);


        }

    });

    var pdfurl = "";
    $(document).on('click', '.download-fp,.download-plans', function (event, formId) {
        event.preventDefault();
        pdfurl = $(this).data('pdf');
        var filename = pdfurl.substring(pdfurl.lastIndexOf('/') + 1);
        // $('#floorplan-download').attr("href", $(this).data('pdf'));
        $('#floorplan-download').attr("href", pdfurl).attr('download', filename);
        $(".mfp-bg").addClass("map-bg");
        // if (window.localStorage.getItem('downloadfloorplan')) {
        // $('#floorplan-download')[0].click();
        // }
        $('#download-file').attr('data-pdf', pdfurl);
    });


    var $window = $(window);
    if ($window.width() >= 768) {
        AOS.init({
            easing: 'ease-in-out-sine',
            duration: 400,
            once: true
        });
    }

    // $(window).on("load", function () {
    if ($window.width() < 768) {
        scrollPan();
    }
    // });

    function scrollPan() {
        var scrollMoveTrigger = $(".mobile-scroll-move-trigger");
        scrollMoveTrigger.each(function (index, item) {
            var curItem = $(item).find(".mobile-scroll-move");
            // var scrollOffset = curItem[0].outerWidth() - $window.width();
            var scrollableWidth = curItem[0].scrollWidth;
            var offset = 0;
            if (curItem.hasClass('withoffset')) {
                offset = 46;
            }
            var scrollOffset = scrollableWidth - $window.width() + offset;
            ScrollTrigger.create({
                trigger: item,
                start: "top top",
                pin: true,
                end: "+=" + scrollOffset,
                onUpdate: (self) => {
                    curItem[0].style.transform = `translate3d(-${self.progress.toFixed(10) * scrollOffset
                        }px, 0, 0)`;
                },
            });

        });
    }
});

